import type { Station } from '@/services/api/schemas/station'

/**
 * Кассы АЗС по ТЗ (п. 1) — две. Плитки рисуются по этому списку, статус к ним подбирается
 * по cash_desk_number из /cashiers: так касса видна даже если бэкенд её не вернул.
 */
export const CASH_DESKS = [
  { number: 1, name: 'Касса №1' },
  { number: 2, name: 'Касса №2' },
] as const

/** Паспорт станции. У API АЗС нет такого эндпоинта — значения заданы здесь. */
export const STATION: Station = {
  id: 'st-m36-1',
  code: 'М36',
  name: 'АЗС №1',
  city: 'Астана',
  address: 'Улица Айнакол, 62/2',
}
